import { render, staticRenderFns } from "./isvweihua.vue?vue&type=template&id=05e88e08"
import script from "./isvweihua.vue?vue&type=script&lang=js"
export * from "./isvweihua.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports